var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"fixed-header":"","disable-pagination":"","hide-default-footer":"","disable-sort":"","dense":"","height":"100%","headers":_vm.headers,"items":_vm.selected}})
}
var staticRenderFns = []

export { render, staticRenderFns }